import { Helmet } from "react-helmet-async";
import LegalDoc from "@/components/LegalDoc";

const ShippingPolicy = () => (
  <>
    <Helmet>
      <title>Shipping Policy | Zentra</title>
      <meta
        name="description"
        content="How Zentra protein bar orders are processed, shipped and delivered across India — timelines, charges and tracking."
      />
    </Helmet>
    <LegalDoc
      testId="shipping-policy-page"
      title="Shipping Policy"
      updated="July 2026"
      intro="This Shipping Policy explains how orders placed on zentrafoods.in are processed, shipped and delivered. ZENTRA products are manufactured and dispatched by Mountain Fresh Farms LLP, Coimbatore, Tamil Nadu, India."
      sections={[
        {
          heading: "1. Order Processing",
          paragraphs: [
            "Orders are processed within 1–2 business days (Monday to Saturday, excluding public holidays) [REVIEW] after payment confirmation. Orders placed on Sundays or public holidays are processed on the next business day.",
            "You will receive an order confirmation by email or WhatsApp once your order is placed successfully.",
          ],
        },
        {
          heading: "2. Shipping Coverage",
          paragraphs: [
            "We currently ship to addresses within India only [REVIEW]. We do not offer international shipping at this time.",
          ],
        },
        {
          heading: "3. Delivery Timelines",
          list: [
            "Metro cities: 2–4 business days from dispatch [REVIEW]",
            "Rest of India: 3–7 business days from dispatch [REVIEW]",
            "Remote or difficult-to-service locations: up to 10 business days [REVIEW]",
          ],
          paragraphs: [
            "Delivery timelines are estimates provided by our courier partners and are not guaranteed. Delays may occur due to weather, strikes, regional restrictions or other events beyond our control.",
          ],
        },
        {
          heading: "4. Shipping Charges",
          list: [
            "Orders below ₹500: flat shipping charge of ₹49 [REVIEW]",
            "Orders of ₹500 and above: free shipping [REVIEW]",
          ],
          paragraphs: [
            "Applicable shipping charges are shown clearly at checkout before you pay.",
          ],
        },
        {
          heading: "5. Order Tracking",
          paragraphs: [
            "Once your order is dispatched, tracking details are shared with you via WhatsApp, SMS or email using the contact information provided at checkout.",
          ],
        },
        {
          heading: "6. Delivery Issues",
          paragraphs: [
            "Please ensure your shipping address and phone number are accurate. We are not responsible for delays or failed deliveries caused by an incorrect or incomplete address provided by the customer. Re-shipping charges may apply in such cases [REVIEW].",
            "If a package is returned to us as undeliverable, we will contact you to arrange re-shipping or issue a refund minus shipping costs [REVIEW].",
          ],
        },
        {
          heading: "7. Damaged in Transit",
          paragraphs: [
            "If your order arrives damaged, please refer to our Refund Policy and report the issue to us within 48 hours of delivery [REVIEW] with clear photographs of the package and product.",
          ],
        },
      ]}
    />
  </>
);

export default ShippingPolicy;
